import type { IConsumer, IConsumerDto } from ".";

export class Consumer implements IConsumer
{

    businessConsumerId: string;
    businessAppId?: string;
    businessAppName?: string;
    consumerId?: string;
    firstName?: string;
    lastName?: string;
    mobile?: string;
    email?: string;
    isEmailVerified: boolean;
    businessName?: string;
    utcDateLastAppActivity?: string;
    canDemo: boolean;

    constructor( model: IConsumerDto )
    {
        this.businessConsumerId = model.businessConsumerId;
        this.businessAppId = model.businessAppId;
        this.businessAppName = model.businessAppName;
        this.consumerId = model.consumerId;
        this.firstName = model.firstName;
        this.lastName = model.lastName;
        this.mobile = model.mobile;
        this.email = model.email;
        this.isEmailVerified = model.isEmailVerified == true;
        this.businessName = model.businessName;
        this.utcDateLastAppActivity = model.utcDateLastAppActivity;
        this.canDemo = model.canDemo;
    }

    /**
     * Gets the full name of the consumer, joining the first and last names
     */
    get fullName()
    {
        return `${ this.firstName ?? '' } ${ this.lastName ?? '' }`.trim();
    }

    /**
     * Gets either the busines name or the full name of the consumer, prioritising the business name
     * if it has one.
     */
    get displayName()
    {
        return this.businessName ?? this.fullName;
    }

    /**
     * True if there is a business name on the consumer
     */
    get isBusiness()
    {
        return this.businessName != null;
    }

    /**
     * True if one or both of the first/last contact names have been provided
     */
    get hasContactName()
    {
        return ( this.firstName ?? this.lastName ) != null;
    }
    
}